import { useSelector } from "react-redux";

/**
 * Custom hook to access the encrypted hotel ID from Redux store
 * @returns {string|null} The encrypted hotel ID or null if not set
 */
const useEncryptedHotelId = () => {
  const encryptedHotelId = useSelector((state) => state.ui.encryptedHotelId);
  return encryptedHotelId;
};

export default useEncryptedHotelId;
